import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
@Injectable({
  providedIn: "root",
})
export class OnboardingService {
  private _storage: Storage | null = null;
  private readonly ONBOARDING_KEY = "hasSeenOnboarding";

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    const storage = await this.storage.create();
    this._storage = storage;
  }

  async hasSeenOnboarding(): Promise<boolean> {
    if (!this._storage) await this.init();
    const seen = await this._storage?.get(this.ONBOARDING_KEY);
    return seen === true;
  }

  async setOnboardingComplete(): Promise<void> {
    if (!this._storage) await this.init();
    await this._storage?.set(this.ONBOARDING_KEY, true);
  }

  async resetOnboarding(): Promise<void> {
    if (!this._storage) await this.init();
    await this._storage?.remove(this.ONBOARDING_KEY);
  }
}
